<script>
import EmployeeManagementTableActionConfirmation from './EmployeeManagementTableActionConfirmation.vue'

export default {
  components: {
    ActionConfirmation: EmployeeManagementTableActionConfirmation
  },
  props: {
    confirmation: {
      type: Boolean
    },
    icon: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: 'primary'
    },
    dialogColor: {
      type: String,
      default: 'primary'
    },
    title: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    disabledOuterButton: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<template>
  <ActionConfirmation
    v-if="confirmation"
    :icon="icon"
    :color="color"
    :dialog-color="dialogColor"
    :title="title"
    :disabled="disabled"
    :disabled-outer-button="disabledOuterButton"
    @confirmed="$emit('confirmed')"
    @activated="$emit('activated')"
    @canceled="$emit('canceled')">
    <template slot="content">
      <slot name="confirmationContent"></slot>
    </template>
    <template slot="tooltip">
      <slot name="tooltip"></slot>
    </template>
  </ActionConfirmation>
  <v-tooltip v-else top>
    <template #activator="{ on, attrs }">
      <v-btn
        icon
        dark
        v-bind="attrs"
        :disabled="disabledOuterButton"
        v-on="on"
        @click="$emit('confirmed')">
        <v-icon :color="color">{{ icon }}</v-icon>
      </v-btn>
    </template>
    <span><slot name="tooltip"></slot></span>
  </v-tooltip>
</template>
